export default __webpack_public_path__ + "eye-open.png";